export const companyInfo = {
    name: "CAPSTONE INNOVATIONS",
    tagline: "Precision. Performance. Partnership.",
    intro:
    "We specialize in manufacturing precision-engineered components for the automotive and industrial sectors, working with aluminium, steel, and galvanized iron to deliver high-quality, reliable, and scalable fabrication, machining, and press solutions that meet strict performance and dimensional standards.",

  email: "info@capstoneinnovations.in",
  phone: "+91 83909 77248 / +91 74208 92350",

  address:
    "Registered Office: 24/46 Nigadi Pradhikaran, Pune – 411044"
};